module.exports = __webpack_public_path__ + "img/1-1.33987b76.svg";